import moment from 'moment';
import Swal from 'sweetalert2';
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'QuestionBanks',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.loginDetails || ![1, 5].includes(this.loginDetails.userType))
            this.logout();

        this.GetInfo(this.pageNo);
        this.selects = [];
        await this.loadChildren(0);
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    filters: {
        moment(date) {
            return date ? moment(date).format('DD/MM/YYYY') : 'فارغ';
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            FilterBy: 1,
            Search: '',
            IsFree: '',
            IsDiscount: '',
            SalesStatus: '',
            ViewStatus: '',
            ScreenTitle: 'بنوك الأسئلة',
            ScreenTitleSingle: 'بنك أسئلة',
            ScreenTitleSingleAl: 'بنك الأسئلة',
            Info: [],
            Statistics: {},
            selects: [],
            SelectedItem: '',
            activeTab: 'Chart',
            ShapterSearch: '',
            ShapterStatistics: {},
            ShapterSelectedItem: '',
            StudentsSearch: '',
            StudentsStatistics: {},
            ShapterScreenTitle: 'الشباتر',
            ShapterScreenTitleSingle: 'شابتر',
            ShapterScreenTitleSingleAl: 'الشابتر',
            ruleForm: {
                Id: '',
                Name: '',
                Code: '',
                AcademicSpecializationId: '',
                SubjectId: '',
                Descriptions: '',
                ContentSummary: '',
                IsFree: false,
                IsDiscount: false,
                Price: '',
                PriceDiscount: '',
                PriceInvoice: '',
                DefaultMotivationalMessage: 'أحسنت! استمر في التعلم',
                Image: '',
                ImageName: ''
            },
            rules: {
                Name: this.$helper.Required(),
                Code: this.$helper.Required(),
                AcademicSpecializationId: this.$helper.Required(),
                SubjectId: this.$helper.Required(),
                Descriptions: this.$helper.Required(),
                Price: this.$helper.Required()
            },
            ShapterInfo: [],
            ShapterruleForm: {
                Id: '',
                QuestionBankId: '',
                Name: '',
                Number: '',
                Descriptions: '',
                Image: '',
                ImageName: ''
            },
            Shapterrules: {
                Name: this.$helper.Required(),
                Number: this.$helper.Required()
            },
            ItemInfo: [],
            SelectedShapterId: '',
            SelectedShapterName: '',
            ItemsDialog: false,
            ItemruleForm: {
                Id: '',
                ShapterId: '',
                Name: '',
                Number: '',
                Descriptions: '',
                HasReadMode: false,
                HasInteractiveMode: false,
                ExamFile: '',
                ExamFileName: '',
                SolutionFile: '',
                SolutionFileName: ''
            },
            QuestionsDialog: false,
            QuestionInfo: [],
            SelectedItemId: '',
            SelectedItemName: '',
            QuestionScreenTitle: ' الأسئلة  ',
            QuestionScreenTitleSingle: ' سؤال',
            QuestionScreenTitleSingleAl: 'السؤال',
            QuestionSelectedItem: '',
            QuestionDifficultyOptions: [
                { id: 1, name: 'سهل' },
                { id: 2, name: 'متوسط' },
                { id: 3, name: 'صعب' }
            ],
            QuestionruleForm: {
                Id: '',
                ItemId: '',
                Number: '',
                Question: '',
                Type: 1,
                Answer: '',
                CompleteAnswer: '',
                A1: '',
                A2: '',
                A3: '',
                A4: '',
                A5: '',
                A1Desc: '',
                A2Desc: '',
                A3Desc: '',
                A4Desc: '',
                A5Desc: '',
                QuestionDate: '',
                DifficultyLevel: 2,
                MotivationalMessage: '',
                Image: '',
                ImageName: ''
            },
            Questionrules: {
                Number: this.$helper.Required(),
                Question: this.$helper.Required(),
                Type: this.$helper.Required(),
                Answer: this.$helper.Required(),
                CompleteAnswer: this.$helper.Required(),
                DifficultyLevel: this.$helper.Required()
            },
            StudentsInfo: []
        };
    },

    methods: {
        async loadChildren(parentId) {
            this.$blockUI.Start();
            try {
                const res = await this.$http.GetAllAcademicSpecializations(parentId);
                this.selects.push({ options: res.data.info, selected: null });
            } finally {
                this.$blockUI.Stop();
            }
        },

        async fillEditSpecializations(parentId) {
            this.selects = [];
            this.ruleForm.AcademicSpecializationId = null;
            this.$blockUI.Start();
            try {
                const pathRes = await this.$http.GetAcademicSpecializationPath(parentId);
                const path = pathRes.data;
                await this.loadChildren(0);

                for (let i = 0; i < path.length; i++) {
                    const currentId = path[i].id;
                    this.selects[i].selected = currentId;
                    this.ruleForm.AcademicSpecializationId = currentId;
                    if (i < path.length - 1)
                        await this.loadChildren(currentId);
                }
            } finally {
                this.$blockUI.Stop();
            }
        },

        onSelectChange(index, selectedId) {
            this.selects = this.selects.slice(0, index + 1);
            this.selects[index].selected = selectedId;
            const selectedItem = this.selects[index].options.find(x => x.id === selectedId);
            if (!selectedItem) {
                this.ruleForm.AcademicSpecializationId = null;
                return;
            }
            this.ruleForm.AcademicSpecializationId = selectedItem.id;
            if (selectedItem.hasChildren)
                this.loadChildren(selectedItem.id);
            this.GetAllSubjects(selectedItem.id);
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined)
                this.pageNo = 1;

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetQuestionBanks(this.pageNo, this.pageSize, this.Search, this.IsFree, this.IsDiscount, this.SalesStatus, this.ViewStatus)
                .then(res => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.Info = res.data.info || [];
                    this.pages = res.data.count || 0;
                    this.Statistics = res.data.statistics || {};
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        ChangeFilter(id) {
            this.FilterBy = id;
            this.IsFree = '';
            this.IsDiscount = '';
            this.SalesStatus = '';
            this.ViewStatus = '';
        },

        Refresh() {
            this.state = 0;
            this.ClearForm(this.ruleForm);
            this.SelectedItem = '';
            this.FilterBy = 1;
            this.Search = '';
            this.IsFree = '';
            this.IsDiscount = '';
            this.SalesStatus = '';
            this.ViewStatus = '';
            this.ItemsDialog = false;
            this.QuestionsDialog = false;
            this.GetInfo(this.pageNo);
        },

        Back() {
            this.state = 0;
            this.ItemsDialog = false;
            this.QuestionsDialog = false;
            this.ClearForm(this.ruleForm);
            this.SelectedItem = '';
            this.GetInfo(this.pageNo);
        },

        OpentInfoDialog(item) {
            this.SelectedItem = item;
            this.state = 3;
            this.activeTab = 'Chart';
            this.ItemsDialog = false;
            this.QuestionsDialog = false;
            this.ShapterSearch = '';
            this.StudentsSearch = '';
            this.GetChartInfo();
        },

        GetChartInfo() {
            // stats shown from SelectedItem — no separate API needed
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Code = item.code;
            this.ruleForm.Descriptions = item.descriptions;
            this.ruleForm.ContentSummary = item.contentSummary;
            this.ruleForm.SubjectId = item.subjectId;
            this.ruleForm.IsFree = item.isFree;
            this.ruleForm.IsDiscount = item.isDiscount;
            this.ruleForm.Price = item.price;
            this.ruleForm.PriceDiscount = item.priceDiscount;
            this.ruleForm.PriceInvoice = item.priceInvoice;
            this.ruleForm.DefaultMotivationalMessage = item.defaultMotivationalMessage || 'أحسنت! استمر في التعلم';
            this.state = 2;
            this.fillEditSpecializations(item.academicSpecializationId);
            this.GetAllSubjects(item.academicSpecializationId);
        },

        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) return this.$helper.showSwal('warning');
                this.ruleForm.Id = Number(0);
                this.normalizePricing();
                this.$blockUI.Start();
                this.$http.AddQuestionBanks(this.ruleForm)
                    .then(res => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                        this.Back();
                    })
                    .catch(err => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ');
                    });
            });
        },

        submitEditForm(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) return this.$helper.showSwal('warning');
                this.ruleForm.Id = Number(this.ruleForm.Id);
                this.normalizePricing();
                this.$blockUI.Start();
                this.$http.EditQuestionBanks(this.ruleForm)
                    .then(res => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                        this.Back();
                    })
                    .catch(err => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ');
                    });
            });
        },

        normalizePricing() {
            this.ruleForm.IsDiscount = Boolean(this.ruleForm.IsDiscount);
            this.ruleForm.IsFree = Boolean(this.ruleForm.IsFree);
            this.ruleForm.Price = Number(this.ruleForm.Price || 0);
            this.ruleForm.PriceDiscount = Number(this.ruleForm.PriceDiscount || 0);
            this.ruleForm.PriceInvoice = Number(this.ruleForm.PriceInvoice || this.ruleForm.Price || 0);
        },

        Delete(id) {
            Swal.fire({
                title: 'تأكيد الحذف',
                text: 'هل أنت متأكد من حذف بنك الأسئلة؟',
                icon: 'question',
                confirmButtonText: 'تأكيد',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false
            }).then(r => {
                if (!r.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.DeleteQuestionBanks(id).then(res => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                    this.GetInfo(this.pageNo);
                }).catch(err => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ');
                });
            });
        },

        ChangeSalesStatus(id) {
            this.$blockUI.Start();
            this.$http.ChangeSalesStatusQuestionBanks(id).then(res => {
                this.$blockUI.Stop();
                this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                this.GetInfo(this.pageNo);
            }).catch(() => this.$blockUI.Stop());
        },

        ChangeStatus(id) {
            this.$blockUI.Start();
            this.$http.ChangeStatusQuestionBanks(id).then(res => {
                this.$blockUI.Stop();
                this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                this.GetInfo(this.pageNo);
            }).catch(() => this.$blockUI.Stop());
        },

        SelectImage(file) {
            if (!file) return;
            if (file.type.substring(0, 5) !== 'image') {
                this.$helper.ShowMessage('error', 'خطأ', 'الرجاء اختيار صورة');
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                this.ruleForm.ImageName = file.name;
                this.ruleForm.Image = reader.result;
            };
            reader.readAsDataURL(file);
        },

        ChangeTab(tab) {
            this.activeTab = tab;
            this.ItemsDialog = false;
            this.QuestionsDialog = false;
            if (tab === 'Chart') this.GetChartInfo();
            else if (tab === 'Shapter') this.GetShapterInfo();
            else if (tab === 'Students') this.GetStudentsInfo();
        },

        GetShapterInfo() {
            if (!this.SelectedItem?.id) return;
            this.ShapterInfo = [];
            this.ShapterStatistics = {};
            if (!this.ShapterSearch)
                this.$blockUI.Start();
            this.$http.GetQuestionBankShapters(this.SelectedItem.id, this.ShapterSearch)
                .then(res => {
                    if (!this.ShapterSearch)
                        this.$blockUI.Stop();
                    this.ShapterInfo = res.data.info || [];
                    this.ShapterStatistics = res.data.statistics || {};
                })
                .catch(() => {
                    if (!this.ShapterSearch)
                        this.$blockUI.Stop();
                });
        },

        GetStudentsInfo() {
            if (!this.SelectedItem?.id) return;
            this.StudentsInfo = [];
            this.StudentsStatistics = {};
            if (!this.StudentsSearch)
                this.$blockUI.Start();
            this.$http.GetQuestionBankStudents(this.SelectedItem.id, this.StudentsSearch)
                .then(res => {
                    if (!this.StudentsSearch)
                        this.$blockUI.Stop();
                    this.StudentsInfo = res.data.info || [];
                    this.StudentsStatistics = res.data.statistics || {};
                })
                .catch(() => {
                    if (!this.StudentsSearch)
                        this.$blockUI.Stop();
                });
        },

        ShaptersubmitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) return this.$helper.showSwal('warning');
                this.ShapterruleForm.Id = Number(0);
                this.ShapterruleForm.QuestionBankId = Number(this.SelectedItem.id);
                this.ShapterruleForm.Number = Number(this.ShapterruleForm.Number);
                if (!this.ShapterruleForm.Descriptions)
                    this.ShapterruleForm.Descriptions = '';
                this.$blockUI.Start();
                this.$http.AddQuestionBankShapters(this.ShapterruleForm).then(res => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                    this.ClearForm(this.ShapterruleForm);
                    this.$helper.DestroyElemntById('Close');
                    this.GetShapterInfo();
                }).catch(err => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ');
                });
            });
        },

        OpentShapterEditDialog(item) {
            this.ShapterOpentEditDialog(item);
        },

        ShapterOpentEditDialog(item) {
            this.ShapterSelectedItem = item;
            this.ShapterruleForm.Id = item.id;
            this.ShapterruleForm.Name = item.name;
            this.ShapterruleForm.Number = item.number;
            this.ShapterruleForm.QuestionBankId = item.questionBankId;
            this.ShapterruleForm.Descriptions = item.descriptions;
        },

        ShaptersubmitEditForm(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) return this.$helper.showSwal('warning');
                this.ShapterruleForm.Id = Number(this.ShapterruleForm.Id);
                this.ShapterruleForm.Number = Number(this.ShapterruleForm.Number);
                this.$blockUI.Start();
                this.$http.EditQuestionBankShapters(this.ShapterruleForm).then(res => {
                    this.$blockUI.Stop();
                    this.GetShapterInfo();
                    this.ClearForm(this.ShapterruleForm);
                    this.$helper.DestroyElemntById('Close');
                    this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                }).catch(err => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ');
                });
            });
        },

        ShapterSelectImage(file) {
            if (!file) return;
            if (file.type.substring(0, 5) !== 'image') {
                this.$helper.ShowMessage('error', 'خطأ', 'الرجاء اختيار صورة');
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                this.ShapterruleForm.ImageName = file.name;
                this.ShapterruleForm.Image = reader.result;
            };
            reader.readAsDataURL(file);
        },

        ShapterChangeStatus(id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من تغيير حالة العرض؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية'
            }).then(r => {
                if (!r.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.ChangeStatusQuestionBankShapters(id).then(res => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                    this.GetShapterInfo();
                }).catch(() => this.$blockUI.Stop());
            });
        },

        ShapterDelete(id) {
            Swal.fire({
                title: 'تأكيد الحذف',
                icon: 'question',
                confirmButtonText: 'تأكيد',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false
            }).then(r => {
                if (!r.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.DeleteQuestionBankShapters(id).then(res => {
                    this.$blockUI.Stop();
                    this.GetShapterInfo();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                }).catch(() => this.$blockUI.Stop());
            });
        },

        DeleteShapter(id) {
            this.ShapterDelete(id);
        },

        OpenItems(shapter) {
            this.SelectedShapterId = shapter.id;
            this.SelectedShapterName = shapter.name;
            this.activeTab = 'Shapter';
            this.ItemsDialog = true;
            this.QuestionsDialog = false;
            this.GetItems();
        },

        BackFromItems() {
            this.ItemsDialog = false;
            this.QuestionsDialog = false;
        },

        GetItems() {
            this.$http.GetQuestionBankItems(this.SelectedShapterId).then(res => {
                this.ItemInfo = res.data.info || [];
            });
        },

        resetItemForm() {
            this.ItemruleForm.Id = '';
            this.ItemruleForm.ShapterId = '';
            this.ItemruleForm.Name = '';
            this.ItemruleForm.Number = '';
            this.ItemruleForm.Descriptions = '';
            this.ItemruleForm.HasReadMode = false;
            this.ItemruleForm.HasInteractiveMode = false;
            this.ItemruleForm.ExamFile = '';
            this.ItemruleForm.ExamFileName = '';
            this.ItemruleForm.SolutionFile = '';
            this.ItemruleForm.SolutionFileName = '';
        },

        submitItemForm() {
            this.ItemruleForm.ShapterId = Number(this.SelectedShapterId);
            this.ItemruleForm.Number = Number(this.ItemruleForm.Number);
            this.ItemruleForm.HasReadMode = Boolean(this.ItemruleForm.HasReadMode);
            this.ItemruleForm.HasInteractiveMode = Boolean(this.ItemruleForm.HasInteractiveMode);

            if (!this.ItemruleForm.Name) {
                this.$helper.ShowMessage('error', 'خطأ', 'اسم المحتوى مطلوب');
                return;
            }
            if (!this.ItemruleForm.Number || this.ItemruleForm.Number <= 0) {
                this.$helper.ShowMessage('error', 'خطأ', 'رقم المحتوى مطلوب');
                return;
            }
            if (!this.ItemruleForm.HasReadMode && !this.ItemruleForm.HasInteractiveMode) {
                this.$helper.ShowMessage('error', 'خطأ', 'يجب تفعيل وضع القراءة أو التفاعلي');
                return;
            }
            const isEdit = Boolean(this.ItemruleForm.Id);
            if (this.ItemruleForm.HasReadMode && !this.ItemruleForm.ExamFile && !isEdit) {
                this.$helper.ShowMessage('error', 'خطأ', 'ملف الامتحان مطلوب لوضع القراءة');
                return;
            }

            if (!isEdit)
                this.ItemruleForm.Id = Number(0);
            else
                this.ItemruleForm.Id = Number(this.ItemruleForm.Id);

            this.$blockUI.Start();
            const req = isEdit
                ? this.$http.EditQuestionBankItems(this.ItemruleForm)
                : this.$http.AddQuestionBankItems(this.ItemruleForm);
            req.then(res => {
                this.$blockUI.Stop();
                this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                this.resetItemForm();
                this.$helper.DestroyElemntById('CloseItem');
                this.GetItems();
            }).catch(err => {
                this.$blockUI.Stop();
                this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ');
            });
        },

        OpentItemEditDialog(item) {
            this.ItemruleForm.Id = item.id;
            this.ItemruleForm.Name = item.name;
            this.ItemruleForm.Number = item.number;
            this.ItemruleForm.Descriptions = item.descriptions;
            this.ItemruleForm.HasReadMode = item.hasReadMode;
            this.ItemruleForm.HasInteractiveMode = item.hasInteractiveMode;
            this.ItemruleForm.ExamFile = '';
            this.ItemruleForm.ExamFileName = '';
            this.ItemruleForm.SolutionFile = '';
            this.ItemruleForm.SolutionFileName = '';
        },

        DeleteItemRow(id) {
            this.$blockUI.Start();
            this.$http.DeleteQuestionBankItems(id).then(res => {
                this.$blockUI.Stop();
                this.GetItems();
                this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
            }).catch(() => this.$blockUI.Stop());
        },

        OpenQuestions(item) {
            this.SelectedItemId = item.id;
            this.SelectedItemName = item.name;
            this.QuestionsDialog = true;
            this.GetQuestions();
        },

        BackFromQuestions() {
            this.QuestionsDialog = false;
        },

        GetQuestions() {
            this.$http.GetQuestionBankQuestions(this.SelectedItemId).then(res => {
                this.QuestionInfo = res.data.info || [];
            });
        },

        resetQuestionForm() {
            this.QuestionruleForm.Id = '';
            this.QuestionruleForm.ItemId = '';
            this.QuestionruleForm.Number = '';
            this.QuestionruleForm.Question = '';
            this.QuestionruleForm.Type = 1;
            this.QuestionruleForm.Answer = '';
            this.QuestionruleForm.CompleteAnswer = '';
            this.QuestionruleForm.A1 = '';
            this.QuestionruleForm.A2 = '';
            this.QuestionruleForm.A3 = '';
            this.QuestionruleForm.A4 = '';
            this.QuestionruleForm.A5 = '';
            this.QuestionruleForm.A1Desc = '';
            this.QuestionruleForm.A2Desc = '';
            this.QuestionruleForm.A3Desc = '';
            this.QuestionruleForm.A4Desc = '';
            this.QuestionruleForm.A5Desc = '';
            this.QuestionruleForm.QuestionDate = '';
            this.QuestionruleForm.DifficultyLevel = 2;
            this.QuestionruleForm.MotivationalMessage = '';
            this.QuestionruleForm.Image = '';
            this.QuestionruleForm.ImageName = '';
        },

        questionTypeLabel(type) {
            if (type === 2) return 'صح / خطأ';
            return 'اختيار متعدد';
        },

        difficultyLabel(level) {
            const item = this.QuestionDifficultyOptions.find(x => x.id === level);
            return item ? item.name : '-';
        },

        normalizeQuestionPayload() {
            this.QuestionruleForm.ItemId = Number(this.SelectedItemId);
            this.QuestionruleForm.Number = Number(this.QuestionruleForm.Number);
            this.QuestionruleForm.Type = Number(this.QuestionruleForm.Type || 1);
            this.QuestionruleForm.Answer = Number(this.QuestionruleForm.Answer);
            this.QuestionruleForm.DifficultyLevel = Number(this.QuestionruleForm.DifficultyLevel || 2);
            if (this.QuestionruleForm.QuestionDate)
                this.QuestionruleForm.QuestionDate = moment(this.QuestionruleForm.QuestionDate).format('YYYY-MM-DD');
            else
                this.QuestionruleForm.QuestionDate = null;
        },

        validateQuestionOptions() {
            if (Number(this.QuestionruleForm.Type) === 1) {
                for (let i = 1; i <= 5; i++) {
                    if (!this.QuestionruleForm['A' + i]) {
                        this.$helper.ShowMessage('error', 'خطأ', 'جميع الخيارات الخمسة مطلوبة');
                        return false;
                    }
                }
            }
            return true;
        },

        submitQuestionAddForm(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) return this.$helper.showSwal('warning');
                if (!this.validateQuestionOptions()) return;
                this.QuestionruleForm.Id = Number(0);
                this.normalizeQuestionPayload();
                this.$blockUI.Start();
                this.$http.AddQuestionBankQuestions(this.QuestionruleForm)
                    .then(res => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                        this.GetQuestions();
                        this.resetQuestionForm();
                        this.$helper.DestroyElemntById('QuestionAddClose');
                    })
                    .catch(err => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ');
                    });
            });
        },

        submitQuestionEditForm(formName) {
            this.$refs[formName].validate(valid => {
                if (!valid) return this.$helper.showSwal('warning');
                if (!this.validateQuestionOptions()) return;
                this.QuestionruleForm.Id = Number(this.QuestionruleForm.Id);
                this.normalizeQuestionPayload();
                this.$blockUI.Start();
                this.$http.EditQuestionBankQuestions(this.QuestionruleForm)
                    .then(res => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                        this.GetQuestions();
                        this.resetQuestionForm();
                        this.$helper.DestroyElemntById('QuestionEditClose');
                    })
                    .catch(err => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'حدث خطأ');
                    });
            });
        },

        QuestionSelectImage(file) {
            if (!file) return;
            const reader = new FileReader();
            reader.onload = () => {
                this.QuestionruleForm.ImageName = file.name;
                this.QuestionruleForm.Image = reader.result;
            };
            reader.readAsDataURL(file);
        },

        OpentQuestionEditDialog(q) {
            this.QuestionSelectedItem = q;
            this.QuestionruleForm.Id = q.id;
            this.QuestionruleForm.ItemId = q.itemId;
            this.QuestionruleForm.Number = q.number;
            this.QuestionruleForm.Question = q.question;
            this.QuestionruleForm.Type = q.type || 1;
            this.QuestionruleForm.Answer = q.answer;
            this.QuestionruleForm.CompleteAnswer = q.completeAnswer;
            this.QuestionruleForm.A1 = q.a1;
            this.QuestionruleForm.A2 = q.a2;
            this.QuestionruleForm.A3 = q.a3;
            this.QuestionruleForm.A4 = q.a4;
            this.QuestionruleForm.A5 = q.a5;
            this.QuestionruleForm.A1Desc = q.a1Desc;
            this.QuestionruleForm.A2Desc = q.a2Desc;
            this.QuestionruleForm.A3Desc = q.a3Desc;
            this.QuestionruleForm.A4Desc = q.a4Desc;
            this.QuestionruleForm.A5Desc = q.a5Desc;
            this.QuestionruleForm.QuestionDate = q.questionDate ? moment(q.questionDate).format('YYYY-MM-DD') : '';
            this.QuestionruleForm.DifficultyLevel = q.difficultyLevel || 2;
            this.QuestionruleForm.MotivationalMessage = q.motivationalMessage;
            this.QuestionruleForm.Image = '';
            this.QuestionruleForm.ImageName = '';
        },

        DeleteQuestionRow(id) {
            this.$blockUI.Start();
            this.$http.DeleteQuestionBankQuestions(id).then(res => {
                this.$blockUI.Stop();
                this.GetQuestions();
                this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
            }).catch(() => this.$blockUI.Stop());
        },

        uploadExamFile(e) {
            const file = e.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = () => {
                this.ItemruleForm.ExamFileName = file.name;
                this.ItemruleForm.ExamFile = reader.result;
            };
            reader.readAsDataURL(file);
        },

        uploadSolutionFile(e) {
            const file = e.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = () => {
                this.ItemruleForm.SolutionFileName = file.name;
                this.ItemruleForm.SolutionFile = reader.result;
            };
            reader.readAsDataURL(file);
        }
    }
};
